import HeadsetInterface from 'resources/headsets/headset-interface';
import {
    disconnectFromPlantronicsHub,
    pollEvents,
    signalIncomingCall,
    signalOutgoingCall,
    signalAnsweringCall,
    signalEndingCall,
    signalHoldingCall,
    signalResumingCall,
    signalMutingCall,
    signalUnmutingCall,
} from 'resources/headsets/plantronics/plantronics-service';
import { hashCodeFromString } from 'flow/utils';

export default class PlantronicsHeadset extends HeadsetInterface {
    attachCallbacks(callbacks) {
        pollEvents(callbacks(this.id));
        return this;
    }
    onDisconnectImpl() {
        disconnectFromPlantronicsHub().catch((e) =>
            super.logError('Failed to disconnect headset', e),
        );
    }
    incomingCallImpl(callId) {
        signalIncomingCall(hashCodeFromString(callId)).catch((e) =>
            super.logError('Error when signaling incoming call', e),
        );
    }
    outgoingCallImpl(callId) {
        signalOutgoingCall(hashCodeFromString(callId)).catch((e) =>
            super.logError('Error when signaling outgoing call', e),
        );
    }
    confirmCallImpl(callId) {
        signalAnsweringCall(hashCodeFromString(callId)).catch((e) =>
            super.logError('Error when signaling answering call', e),
        );
    }
    endCallImpl(callId) {
        signalEndingCall(hashCodeFromString(callId)).catch((e) =>
            super.logError('Error when signaling end call', e),
        );
    }
    holdCallImpl(callId) {
        signalHoldingCall(hashCodeFromString(callId)).catch((e) =>
            super.logError('Error when signaling hold call', e),
        );
    }
    resumeCallImpl(callId) {
        signalResumingCall(hashCodeFromString(callId)).catch((e) =>
            super.logError('Error when signaling resume call', e),
        );
    }
    muteCallImpl() {
        signalMutingCall().catch((e) =>
            super.logError('Error when signaling mute call', e),
        );
    }
    unmuteCallImpl() {
        signalUnmutingCall().catch((e) =>
            super.logError('Error when signaling unmute call', e),
        );
    }
}
